import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
 
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        if (request.headers.get('No-Auth') == "True")
        {
          return next.handle(request.clone());
        }
        else
        {
            let currentUser = localStorage.getItem('userToken');

            if (currentUser) {
                request = request.clone({
                    setHeaders: { 
                        Authorization: `Bearer ${currentUser}`
                    }
                });
            }
     
            return next.handle(request);
        }
    }
}